/** Nieuwe set met `value` omgeschakeld: weg als het erin zat, anders erbij. Puur. */
export function toggledInSet<T>(set: ReadonlySet<T>, value: T): Set<T> {
  const next = new Set(set);
  if (next.has(value)) {
    next.delete(value);
  } else {
    next.add(value);
  }
  return next;
}
